import React from "react";
import { EXAM_TYPE, EXAM_TYPE_LABEL, EXAM_TYPE_COLOR_BG, EXAM_TYPE_COLOR_TEXT, EXAM_TYPE_COLOR_BORDER } from "../../utils";

const EXAM_TYPES = Object.values(EXAM_TYPE).filter((type) => type !== EXAM_TYPE.DEFAULT);

const ExamTypeSelect = ({ value = [], onChange }) => {
  const onToggle = (type) => {
    if (value.includes(type)) onChange(value.filter((t) => t !== type));
    else onChange([...value, type]);
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {EXAM_TYPES.map((type) => {
        const selected = value.includes(type);
        return (
          <button
            key={type}
            type="button"
            onClick={() => onToggle(type)}
            className={`rounded-md border px-2.5 py-1 text-xs font-medium transition-all ${
              selected
                ? `${EXAM_TYPE_COLOR_BG[type]} ${EXAM_TYPE_COLOR_TEXT[type]} ${EXAM_TYPE_COLOR_BORDER[type]}`
                : "border-gray-200 bg-white text-gray-500 hover:bg-gray-50"
            }`}
          >
            {EXAM_TYPE_LABEL[type] || type}
          </button>
        );
      })}
    </div>
  );
};

export default ExamTypeSelect;
